<div class="margin-top-15">
    <form [formGroup]="_filterForm" class="padding">
        <div class="flex-container">
            <mat-form-field class="form-field">
                <mat-label>{{ 'common.labels.username' | transloco }}</mat-label>
                <input matInput formControlName="username" [placeholder]="'common.labels.username' | transloco" />
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
                <input matInput formControlName="firstName" [placeholder]="'common.labels.firstName' | transloco" />
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
                <input matInput formControlName="middleName" [placeholder]="'common.labels.middleName' | transloco" />
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
                <input matInput formControlName="lastName" [placeholder]="'common.labels.lastName' | transloco" />
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>{{ 'common.labels.email' | transloco }}</mat-label>
                <input matInput formControlName="email" [placeholder]="'common.labels.email' | transloco" />
            </mat-form-field>
            <mat-checkbox formControlName="isActive" class="form-field">
                {{ 'common.labels.active' | transloco }}
            </mat-checkbox>
            <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
                (click)="onFilter()">
                {{ 'common.labels.filter' | transloco }}
            </button>
        </div>
    </form>
</div>